import { ArticleHeading1, ArticleHeading2, Button, Modal, Responsive, ArticleHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ReplyTemplateModalError.css';

type TProps = {
  onClose: () => void;
  onRetry: () => void;
};

export const ReplyTemplateModalError: React.FC<TProps> = ({ onClose, onRetry }) => {
  return (
    <Modal
      open
      size="S"
      onOpenChange={onClose}
      header={
        <>
          <Responsive desktop>
            <ArticleHeading1>Шаблоны ответа</ArticleHeading1>
          </Responsive>
          <Responsive phone tablet>
            <ArticleHeading2>Шаблоны ответа</ArticleHeading2>
          </Responsive>
        </>
      }
    >
      <div className={styles['container']}>
        <div className={styles['error-wrapper']}>
          <div className={styles['error-sign']} />
        </div>
        <div className={styles['text']}>
          <ArticleHeading4>Не получилось загрузить шаблоны</ArticleHeading4>
          <UIText2>Давайте попробуем снова</UIText2>
        </div>
        <Button theme="fill_secondary" size="XS" onClick={onRetry}>
          Попробовать ещё раз
        </Button>
      </div>
    </Modal>
  );
};
